/**
 * Composant Dialog réutilisable pour l'affichage de contenu modal
 * Utilise createPortal pour le rendu dans le DOM
 */

import { X } from "lucide-react";
import { createPortal } from "react-dom";
import { cn } from "@repo/utils";

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export function Dialog({
  isOpen,
  onClose,
  title,
  children,
  className,
}: DialogProps) {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className={cn(
          "relative max-h-[85vh] w-full max-w-5xl overflow-auto rounded-lg bg-background p-6 shadow-2xl mx-4",
          className
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-lg p-2 hover:bg-muted transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
        {title && (
          <h2 className="mb-4 text-xl font-bold text-foreground">{title}</h2>
        )}
        <div className="overflow-auto">{children}</div>
      </div>
    </div>,
    document.body,
  );
}

// Export également sous le nom DocumentModal pour la rétrocompatibilité
export { Dialog as DocumentModal };
